import { Typography, Icon } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";

export const ErrorMessage = ({ errorMessage }: { errorMessage: string }) => {
  if (!errorMessage) return null;

  return (
    <div
      style={{
        marginTop: "4px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Icon.Warning style={{ width: 16, color: defaultTheme.COLORS.ERROR }} />
      <Typography
        variant="body-x-small"
        color="ERROR"
        sx={{
          marginLeft: "4px",
        }}
      >
        {errorMessage}
      </Typography>
    </div>
  );
};
